// @ts-nocheck

import { isSavedAdAccount } from '../components/PartnerManager/utils';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type { SnapAdsAccount } from '../types/adPartnerTypes';
const SNAP_ROUTE = '/v1/snap';
const GetAccounts = new ReduxAsyncAction('SNAP_GET_ACCOUNTS');
GetAccounts.registerRequest((savedAccounts: SnapAdsAccount[]) => {
  return dash_api.get(`${SNAP_ROUTE}/get-accounts`).then(({ data }) => {
    return {
      accounts: data.map((account) => ({ ...account, checked: isSavedAdAccount(account.id, savedAccounts) })),
    };
  });
});
export const GET_ACCOUNTS = GetAccounts.constants;
export const getAccounts = GetAccounts.request;
